<template>
	<div>

	</div>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';

	@Component({
		components: {
		},
	})
	export default class MyComponent extends Vue {
	}
</script>

<style lang="scss">

</style>